export default {
  footerLink: [
    {
      title: '产品服务',
      id: 'cpfw',
      children: [
        // {
        //   url: 'https://www.esign.cn/landing/mixOs',
        //   title: '天印电子签章软件',
        // },
        // {
        //   url: '/gw/csym1/cszym/',
        //   title: 'SaaS（智能合同）',
        // },
        // {
        //   url: '/pcgw/cp/eqbddb/',
        //   title: '融合产品（钉钉版）',
        // },

        // {
        //   url: '/cs/eqbtyzx/',
        //   title: '体验中心',
        // },
        // {
        //   url: 'https://open.esign.cn/',
        //   title: '开放平台',
        // },
        {
          title: '签管一体化电子合同云平台',
          url: '/product/platform',
        },
        {
          title: '企业统一印章平台',
          url: '/product/corporate',
        },
        {
          title: '钉钉智能合同',
          url: '/product/dingcoop',
        },
        {
          title: '开放服务',
          url: '/product/apiservice',
        },
        {
          title: '身份认证',
          url: '/product/verifyservice',
        },
      ],
    },
    {
      title: '快速入口',
      id: 'ksrk',
      children: [
        {
          url: 'https://h5.esign.cn/usercenterFront/regist?pub=esign',
          title: '立即注册',
          nofollow: true,
        },
        {
          url: 'https://web.esign.cn/workspace/home',
          title: '立即登录',
          nofollow: true,
        },
        {
          url: 'https://help.esign.cn/',
          title: '客服中心',
        },
        {
          url: '/pcgw/cp/xzgz/',
          title: '下载关注',
        },
      ],
    },
    {
      title: '诚邀合作',
      id: 'cyhz',
      children: [
        {
          url: '/gfqd/',
          title: '渠道合作',
        },

        {
          url: '/site/ecological',
          title: '生态合作',
        },
      ],
    },
    {
      title: '关于我们',
      id: 'gywm',
      children: [
        {
          url: '/pcgw/gywm/gsjs/',
          title: '公司介绍',
        },
        {
          url: '/pcgw/gywm/gsxw/',
          title: '公司动态',
        },
        {
          url: '/pcgw/gywm/jszz/',
          title: '技术资质',
        },
        {
          url: 'https://esign.zhiye.com/',
          title: '加入我们',
        },
        {
          url: '/pcgw/gywm/lxwm/',
          title: '联系我们',
        },
      ],
    },
  ],
  hotline: [
    {
      url: 'tel:4000878198',
      id: 'kefu-tel',
      title: '400-0878-198',
      desc: '客服热线',
    },
    {
      url: 'tel:0571-85785223',
      id: 'sale-tel',
      title: '0571-85785223',
      desc: '销售热线',
    },
    {
      url: 'mailto: market@esign.cn',
      id: 'business-mail',
      title: 'market@esign.cn',
      desc: '商务合作',
    },
    {
      url: 'mailto: CEO@esign.cn',
      id: 'ceo-mail',
      title: 'CEO@esign.cn',
      desc: 'CEO直达信箱',
    },
  ],
  otherLine: [
    {
      id: 'wx',
      imgUrl: 'https://www.esign.cn/images/weixinduck.png',
      activeImgUrl: 'https://www.esign.cn/images/wxlight.png',
      title: '关注微信公众号',
      code: 'https://www.esign.cn/images/footerone.png',
    },
    {
      id: 'wb',
      imgUrl: 'https://www.esign.cn/images/weiboduck.png',
      activeImgUrl: 'https://www.esign.cn/images/wblight.png',
      title: '关注微博',
      code: 'https://www.esign.cn/images/footertwo.png',
    },
    {
      id: 'alipay',
      imgUrl: 'https://www.esign.cn/images/zfbduck.png',
      activeImgUrl: 'https://www.esign.cn/images/zfblight.png',
      title: '体验支付宝小程序',
      code: 'https://www.esign.cn/images/footerthree.png',
    },
  ],
  friendLink: [
    {
      url: 'http://fawuren.com/',
      title: '亚太法务联盟',
    },
    {
      url: 'https://www.alibabagroup.com/cn/global/home',
      title: '阿里巴巴',
    },
    {
      url: 'https://www.antgroup.com/',
      title: '蚂蚁金服',
    },
    {
      url: 'https://www.dingtalk.com/',
      title: '钉钉',
    },
    {
      url: 'https://www.aliyun.com/',
      title: '阿里云',
    },
    {
      url: 'https://www.ruc.edu.cn/',
      title: '中国人民大学',
    },
    {
      url: 'https://www.buaa.edu.cn/',
      title: '北京航空航天大学',
    },
    {
      url: 'https://www.yonyoucloud.com/',
      title: '用友云',
    },
    {
      url: 'https://www.huawei.com/cn/?ic_medium=direct&ic_source=surlent',
      title: '华为',
    },
    {
      url: 'https://www.ti-net.com.cn/',
      title: '呼叫中心',
    },
    {
      url: 'https://www.weiling.cn/',
      title: '卫瓴',
    },
  ],

  // 数据copy泽元系统的 Site.config_banquan 字段
  siteConfigBanquan:
    '<span>Copyright © 2021 杭州天谷信息科技有限公司版权所有.</span><span>增值电信业务经营许可证浙B2-20180376号<a target="_blank" href="http://beian.miit.gov.cn" rel="nofollow">浙ICP备11026113号-4</a><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602010810" rel="nofollow">浙公网安备33010602010810号</a></span>',

  // 数据copy泽元系统的 服务协议(gw/fwxy)栏目内容
  // 注意: 栏目内容(即协议)顺序调整后, 这里的顺序也要随之变化, current字段取的是当前对应协议序号
  agreementLink: [
    {
      url: 'https://www.esign.cn/gw/fwxy?current=1',
      title: 'e签宝服务协议',
    },
    {
      url: 'https://www.esign.cn/gw/fwxy?current=2',
      title: '隐私政策',
    },
    {
      url: 'https://www.esign.cn/gw/fwxy?current=3',
      title: 'e签宝服务等级协议',
    },
    {
      url: 'https://www.esign.cn/gw/fwxy?current=4',
      title: '历史版本协议',
    },
  ],
}
